module.exports = __webpack_public_path__ + "87053a32.png";